export default __webpack_public_path__ + "static/media/captainbee.a438f1d3.svg";